import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCustomTost } from "../../utiils/useCustomTost";
import { cleareApiError } from "../../redux/reducer/errorStore";

const ErrorHandleToast = () => {
  const errormessage = useSelector((state) => state?.errorStore?.errorMessage);
  const toast = useCustomTost();
  const dispatch=useDispatch()

  useEffect(() => {
    if (errormessage) {
      toast("An error occurred.", errormessage, "error");
      dispatch(cleareApiError())
    }
  }, [errormessage, toast]);

  return null; 
};

export default ErrorHandleToast;
